interface INav {
  name: string,
  to: string,
  category: string,
  isExternal?: boolean; // Add isExternal property for external links
  target?: string; // Add this line
}

export const itemsNav: INav[] = [
  {
    name: 'Home',
    to: 'https://ckayb-47be2.web.app/', // Replace with your external URL
    category: '',
    isExternal: true, // Specify isExternal for external links
    target: '_self' // Add this line to open the link in the same tab
},

  {
    name: 'Blanketi Collection',
    to: '/',
    category: 'Blanketi'
  },
  {
    name: 'Dhahabu Collection',
    to: '/',
    category: 'Dhahabu'
  },
  {
    name: 'Corporate',
    to: '/',
    category: 'KCB'
  },
  {
    name: 'Chakata',
    to: '/',
    category: 'Chakata'
  },
  {
    name: 'Athleisure',
    to: '/',
    category: 'Athleisure'
  },
  {
    name: 'Afro Collection',
    to: '/',
    category: 'Afro'
  },
  {
    name: 'CKB Collection',
    to: '/',
    category: 'CKB'
  }
]
